// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3P5LX","text":"SelectPayment_text__2Yi6t","title":"SelectPayment_title__fqlrR","btn":"SelectPayment_btn__3yX3b"};